// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [5,[2]],
		"/(app)/admin": [6,[2,3]],
		"/(app)/admin/settings": [7,[2,3]],
		"/auth": [27],
		"/(app)/c/[id]": [8,[2]],
		"/error": [28],
		"/s/[id]": [29],
		"/(app)/workspace": [9,[2,4]],
		"/(app)/workspace/assets": [10,[2,4]],
		"/(app)/workspace/documents": [11,[2,4]],
		"/(app)/workspace/models": [12,[2,4]],
		"/(app)/workspace/models/applications": [13,[2,4]],
		"/(app)/workspace/models/create": [14,[2,4]],
		"/(app)/workspace/models/edit": [15,[2,4]],
		"/(app)/workspace/models/group": [16,[2,4]],
		"/(app)/workspace/models/usergroups": [17,[2,4]],
		"/(app)/workspace/playground": [18,[2,4]],
		"/(app)/workspace/pricing": [19,[2,4]],
		"/(app)/workspace/prompts": [20,[2,4]],
		"/(app)/workspace/prompts/create": [21,[2,4]],
		"/(app)/workspace/prompts/edit": [22,[2,4]],
		"/(app)/workspace/tools": [23,[2,4]],
		"/(app)/workspace/tools/create": [24,[2,4]],
		"/(app)/workspace/tools/edit": [25,[2,4]],
		"/(app)/workspace/utilization": [26,[2,4]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);